import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.jsx';
import './index.css';

// Error boundary component
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Error caught by boundary:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-cream flex items-center justify-center p-6">
          <div className="text-center">
            <img
              src="https://cdn1.sharemyimage.com/smi/2025/10/21/Logo-Lavie-Saigon.jpeg"
              alt="La Vie Saigon"
              className="h-16 w-16 mx-auto mb-4 rounded-full"
            />
            <h1 className="text-2xl font-playfair text-warm-brown mb-4">Oops! Something went wrong</h1>
            <p className="text-warm-brown/70 mb-4">We're sorry for the inconvenience. Please refresh the page.</p>
            <button
              onClick={() => window.location.reload()}
              className="bg-warm-brown text-cream px-6 py-3 rounded-lg font-medium hover:bg-warm-brown/90 transition-colors"
            >
              Refresh Page
            </button>
            <details className="mt-4 text-left">
              <summary className="cursor-pointer text-warm-brown/70">Error Details</summary>
              <pre className="mt-2 p-4 bg-red-50 rounded text-xs text-red-700 overflow-auto">
                {this.state.error?.toString()}
              </pre>
            </details>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

const root = createRoot(document.getElementById('root'));

root.render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
);